/**
 *@description: 会员之窗
 *@author: 刘宇凡
 *@fileName: index.tsx 
 *@date: 2022-08-26 17:06:38
 *@email: 1982338226@qq.com
*/
import { FC } from 'react';
import Tab from '@/components/Tab';
import { getMemberUnitInfo, getMemberUnitList } from '@/api/associationOfHome';

const Members: FC = () => {
    const queryData={
        current: '1',
        pageSize: 30,
        ifPay:'1'
    }
    const getList = async (e:any) => {
        const requestData = {...queryData,...e}
        const res = await getMemberUnitList(requestData)
        return {
            list: res.data.data.list,
            total: res.data.data.total || 0
        }
    }
    const getDetails = async (e:any) => {
        const res = await getMemberUnitInfo(e)
        return res.data.data
    }
    return (
        <>  
            <Tab request={getList} 
            requestDetails={getDetails} 
            queryProps={{queryData:queryData}} 
            pageSize={queryData.pageSize}
            detailsContentProps={{showDatya:{title:'memberName',content:'memberContent',time:'createTime'},toPath:'/associationOfHome'}} 
            contentProps={{calssName:'grid-5', showDatya:{cardTitle:'memberName', cardFileList:'fileList',cardId:'memberId'},cardType:'4'}}></Tab>
        </>
    );
}
export default Members